import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Servicedetails = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title" id="breadcrumb-title">
            Program Details
          </h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li><Link to="/services">Programs</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li id="breadcrumb-program">Program Details</li>
          </ul>
        </div>
      </section>

      <section className="ul-service-details ul-section-spacing">
        <div className="ul-container">
          <div>

            <div
              className="ul-service-details-img"
              style={{
                borderRadius: 'clamp(15px, 1.05vw, 20px)',
                overflow: 'hidden',
                marginBottom: 'clamp(30px, 3.15vw, 60px)'
              }}
            >
              <img
                id="hero-image"
                src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg"
                alt="Program Image"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '60vh',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div className="ul-service-details-txt">
              <h2
                className="ul-service-details-title"
                id="program-title"
                style={{
                  color: 'var(--ul-primary)',
                  marginBottom: 'clamp(20px, 2.1vw, 40px)'
                }}
              >
                Health Literacy Education
              </h2>

              <p
                className="ul-service-details-descr"
                id="program-intro"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(20px, 2.1vw, 30px)'
                }}
              >
                We create clear, accurate, and engaging educational content on
                common health diseases. Our content is science-based, easy to
                understand, visually engaging, and social media friendly.
              </p>

              <p
                className="ul-service-details-descr"
                id="program-description"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(30px, 3.15vw, 50px)'
                }}
              >
                Pathio's Health Literacy Education program bridges the gap
                between complex medical information and accessible,
                culturally-relevant health education. We partner with medical
                mentors and Gen-Z creators to produce content that resonates
                with multilingual communities across New York City.
              </p>

              <div
                className="ul-service-details-inner-block"
                style={{
                  background: 'var(--ul-c3)',
                  padding: 'clamp(25px, 2.63vw, 40px)',
                  borderRadius: 'clamp(10px, 0.84vw, 15px)',
                  marginBottom: 'clamp(30px, 3.15vw, 50px)'
                }}
              >
                <h3
                  className="ul-service-details-inner-title"
                  id="features-title"
                  style={{
                    color: 'var(--ul-primary)',
                    marginBottom: 'clamp(15px, 1.58vw, 25px)',
                    fontSize: 'clamp(22px, 1.68vw, 28px)'
                  }}
                >
                  What We Offer
                </h3>
                <ul
                  id="features-list"
                  style={{listStyle: 'none', padding: 0, margin: 0}}
                >
                  <li
                    style={{
                      padding: 'clamp(10px, 1.05vw, 15px) 0',
                      borderBottom: '1px solid rgba(43, 122, 143, 0.1)',
                      display: 'flex',
                      alignItems: 'start',
                      gap: 'clamp(10px, 1.05vw, 15px)'
                    }}
                  >
                    <span
                      style={{
                        fontSize: 'clamp(15px, 1.05vw, 18px)',
                        lineHeight: 1.7
                      }}
                      >Science-based content on common health diseases</span
                    >
                  </li>
                  <li
                    style={{
                      padding: 'clamp(10px, 1.05vw, 15px) 0',
                      borderBottom: '1px solid rgba(43, 122, 143, 0.1)',
                      display: 'flex',
                      alignItems: 'start',
                      gap: 'clamp(10px, 1.05vw, 15px)'
                    }}
                  >
                    <span
                      style={{
                        fontSize: 'clamp(15px, 1.05vw, 18px)',
                        lineHeight: 1.7
                      }}
                      >Multilingual content in Uzbek, Russian, Mandarin,
                      Spanish, and English</span
                    >
                  </li>
                  <li
                    style={{
                      padding: 'clamp(10px, 1.05vw, 15px) 0',
                      borderBottom: '1px solid rgba(43, 122, 143, 0.1)',
                      display: 'flex',
                      alignItems: 'start',
                      gap: 'clamp(10px, 1.05vw, 15px)'
                    }}
                  >
                    <span
                      style={{
                        fontSize: 'clamp(15px, 1.05vw, 18px)',
                        lineHeight: 1.7
                      }}
                      >Social media-friendly visual explainers and
                      infographics</span
                    >
                  </li>
                  <li
                    style={{
                      padding: 'clamp(10px, 1.05vw, 15px) 0',
                      display: 'flex',
                      alignItems: 'start',
                      gap: 'clamp(10px, 1.05vw, 15px)'
                    }}
                  >
                    <span
                      style={{
                        fontSize: 'clamp(15px, 1.05vw, 18px)',
                        lineHeight: 1.7
                      }}
                      >Culturally-relevant messaging that resonates with diverse
                      communities</span
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="ul-service-details-video-cover"
              style={{
                position: 'relative',
                borderRadius: 'clamp(15px, 1.05vw, 20px)',
                overflow: 'hidden',
                marginBottom: 'clamp(30px, 3.15vw, 50px)'
              }}
            >
              <img
                id="secondary-image"
                src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg"
                alt="Program Image"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '50vh',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div className="ul-service-details-txt">
              <p
                className="ul-service-details-descr"
                id="program-impact"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(30px, 3.15vw, 50px)'
                }}
              >
                Our Health Literacy Education program empowers communities with
                knowledge they can trust. By combining medical expertise with
                creative storytelling, we make complex health information
                accessible and actionable for everyone, regardless of language
                or background.
              </p>

              <div
                className="ul-service-details-inner-block"
                style={{
                  background: 'linear-gradient(135deg, var(--ul-primary) 0%, var(--ul-secondary) 100%)',
                  padding: 'clamp(30px, 3.15vw, 50px)',
                  borderRadius: 'clamp(10px, 0.84vw, 15px)',
                  color: 'var(--white)'
                }}
              >
                <h3
                  className="ul-service-details-inner-title"
                  id="cta-title"
                  style={{
                    color: 'var(--white)',
                    marginBottom: 'clamp(15px, 1.58vw, 25px)',
                    fontSize: 'clamp(22px, 1.68vw, 28px)'
                  }}
                >
                  Get Involved
                </h3>
                <p
                  className="ul-service-details-descr"
                  id="cta-description"
                  style={{
                    color: 'rgba(255, 255, 255, 0.95)',
                    fontSize: 'clamp(15px, 1.05vw, 18px)',
                    lineHeight: 1.8,
                    marginBottom: 'clamp(20px, 2.1vw, 30px)'
                  }}
                >
                  Whether you're a healthcare professional, content creator, or
                  community member, there's a place for you in our Health
                  Literacy Education program. Join us in making health
                  information accessible to all.
                </p>
                <Link to="/contact"
                  className="ul-btn"
                  style={{background: 'var(--white)', color: 'var(--ul-primary)'}}
                >
                  <i
                    className="flaticon-fast-forward-double-right-arrows-symbol"
                  ></i>
                  Contact Us to Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

      <Footer />
    </>
  );
};

export default Servicedetails;
